module.exports = __webpack_public_path__ + "static/maxandmilo1-5db8fc3c446ac07553320107ec49cc07.png";